import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface KpiItem {
    label: string;
    value: string;
    trend?: 'up' | 'down' | 'neutral';
    trendValue?: string;
    color?: string;
}

interface KpiBlockData {
    items: KpiItem[];
}

interface KpiBlockProps {
    data: KpiBlockData;
}

const trendColors: Record<string, string> = {
    up: 'text-green-600',
    down: 'text-red-600',
    neutral: 'text-gray-500',
};

const bgColors: Record<string, string> = {
    green: 'bg-green-50 border-green-200',
    red: 'bg-red-50 border-red-200',
    blue: 'bg-blue-50 border-blue-200',
    purple: 'bg-purple-50 border-purple-200',
    yellow: 'bg-yellow-50 border-yellow-200',
    orange: 'bg-orange-50 border-orange-200',
};

export const KpiBlock: React.FC<KpiBlockProps> = ({ data }) => {
    const columns = data.items.length <= 2 ? 2 : data.items.length <= 4 ? data.items.length : 4;

    return (
        <div className={`grid grid-cols-${columns} gap-3 mt-2`} style={{ gridTemplateColumns: `repeat(${columns}, minmax(0, 1fr))` }}>
            {data.items.map((item, idx) => {
                const colorClass = item.color ? bgColors[item.color] || 'bg-gray-50 border-gray-200' : 'bg-gray-50 border-gray-200';

                return (
                    <div key={idx} className={`p-3 rounded-lg border ${colorClass}`}>
                        <p className="text-xs text-gray-500 font-medium mb-1">{item.label}</p>
                        <p className="text-xl font-bold text-gray-900">{item.value}</p>
                        {item.trend && (
                            <div className={`flex items-center gap-1 mt-1 text-xs ${trendColors[item.trend]}`}>
                                {item.trend === 'up' && <TrendingUp size={12} />}
                                {item.trend === 'down' && <TrendingDown size={12} />}
                                {item.trend === 'neutral' && <Minus size={12} />}
                                {item.trendValue && <span>{item.trendValue}</span>}
                            </div>
                        )}
                    </div>
                );
            })}
        </div>
    );
};
